import type { CardList } from '../models/layout.model';

/**
 * Keeps the first occurrence of each `cardId`. Duplicate rows break GridStack:
 * it renames later widgets to `${cardId}_1`, which then fail component create.
 */
export function dedupeLayoutCardsByCardId(
	cards: readonly CardList[]
): CardList[] {
	const seen = new Set<string>();
	const result: CardList[] = [];
	for (const card of cards) {
		const id = card.cardId?.trim();
		if (!id || seen.has(id)) {
			continue;
		}
		seen.add(id);
		result.push(card);
	}
	// Preserve identity when nothing was dropped so callers can no-op cheaply.
	if (result.length === cards.length) {
		return cards as CardList[];
	}
	return result;
}
